import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLogout = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "58px",
	height: "43px",
	viewBox: "0 0 58 43",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Unvollst\\xE4ndige-Bewertungen",
			transform: "translate(-5.000000, -76.000000)",
			fill: "#FFFFFF",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "login",
				transform: "translate(5.774775, 76.522523)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M37.5899425,22.2252252 L3.0136611,22.2252252 C2.02644103,22.2252252 1.22522523,21.4482916 1.22522523,20.490991 C1.22522523,19.5336903 2.02644103,18.7567568 3.0136611,18.7567568 L37.5899425,18.7567568 C38.5771626,18.7567568 39.3783784,19.5336903 39.3783784,20.490991 C39.3783784,21.4482916 38.5771626,22.2252252 37.5899425,22.2252252 Z",
						id: "Path",
						transform: "translate(20.301802, 20.490991) scale(-1, 1) translate(-20.301802, -20.490991) "
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M1.82371705,32.1351351 C1.35654268,32.1351351 0.889813639,31.9603196 0.534422572,31.6076137 C-0.178140857,30.9048374 -0.178140857,29.7654612 0.534422572,29.0622457 L8.97429106,20.7387388 L0.534422572,12.4147926 C-0.178140857,11.7120163 -0.178140857,10.5722009 0.534422572,9.86942458 C1.24743132,9.16664826 2.40267484,9.16664826 3.11523827,9.86942458 L12.8439558,19.4649567 C13.5565192,20.167733 13.5565192,21.3071091 12.8439558,22.0098854 L3.11523827,31.6049783 C2.75762047,31.9603196 2.29089142,32.1351351 1.82371705,32.1351351 L1.82371705,32.1351351 Z",
						id: "Path",
						transform: "translate(6.689189, 20.738739) scale(-1, 1) translate(-6.689189, -20.738739) "
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M35.9146684,42 C27.1907633,42 19.4889469,36.7729837 16.2896553,28.6819975 C15.9983319,27.9489638 16.3623107,27.1166541 17.1004467,26.8265168 C17.8364769,26.5402247 18.6742946,26.8971286 18.965618,27.6361049 C21.7279246,34.6214232 28.381328,39.1363795 35.9146684,39.1363795 C45.9551442,39.1363795 54.1251839,30.9996005 54.1251839,21 C54.1251839,11.0003995 45.9551442,2.86362047 35.9146684,2.86362047 C28.381328,2.86362047 21.7279246,7.37857677 18.965618,14.3638951 C18.6721887,15.1028714 17.8364769,15.4597753 17.1004467,15.1734832 C16.3623107,14.8833459 15.9983319,14.0510362 16.2896553,13.3180025 C19.4889469,5.22701629 27.1907633,0 35.9146684,0 C47.5405748,0 57.0005099,9.42142321 57.0005099,21 C57.0005099,32.5785768 47.5405748,42 35.9146684,42 Z",
						id: "Path"
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconLogout);
export { ForwardRef as ReactComponent };
